import React, { useMemo, useState } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
import { skillCategories, skills } from '../data/skills';
import type { SkillCategory } from '../data/skills';
const EASE = [0.23, 1, 0.32, 1] as const;
export function SkillsExplorer() {
  const [active, setActive] = useState<'All' | SkillCategory>('All');
  const visible = useMemo(() => active === 'All' ? skills : skills.filter(s => s.category === active), [active]);
  const counts = useMemo(() => {
    const map: Record<string, number> = {
      All: skills.length
    };
    skills.forEach(s => {
      map[s.category] = (map[s.category] ?? 0) + 1;
    });
    return map;
  }, []);
  return <section className="bg-offwhite py-16 lg:py-20" data-id="element-236" data-mp="3fadu6q4hd2kz">
      <div className="mx-auto max-w-shell px-6 lg:px-8" data-id="element-237" data-mp="qhig3pf30pvb">
        <div role="tablist" aria-label="Skill categories" className="flex flex-wrap gap-2 border-b border-mist pb-6" data-id="element-238" data-mp="qgywm49s9tf6">
          {skillCategories.map(category => {
          const selected = category === active;
          return <button key={category} role="tab" aria-selected={selected} onClick={() => setActive(category)} className={`border px-4 py-2 text-sm font-semibold transition-colors duration-150 ease-out ${selected ? 'border-navy bg-navy text-white' : 'border-mist bg-white text-charcoal hover:border-navy hover:text-navy'}`} data-id="element-239" data-mp="1xyz6cbd3tz0e">
                {category}
                <span className={`ml-2 text-xs font-medium ${selected ? 'text-gold-light' : 'text-slate-400'}`} data-id="element-240" data-mp="1a8wftzou913w">
                  {counts[category] ?? 0}
                </span>
              </button>;
        })}
        </div>

        <ul className="mt-10 grid gap-px bg-mist md:grid-cols-2 xl:grid-cols-3" data-id="element-241" data-mp="w9dj031h9c6w">
          {visible.map((skill, index) => <motion.li key={skill.name} layout initial={{
          opacity: 0,
          y: 8
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.22,
          ease: EASE,
          delay: Math.min(index, 8) * 0.02
        }} className="flex flex-col bg-white p-6" data-id="element-242" data-mp="qml7e0lsjtui" data-mpi={index}>
              <div className="flex items-baseline justify-between gap-4" data-id="element-243" data-mp="15dtsbwer0r1b">
                <h3 className="font-serif text-lg leading-snug text-navy" data-id="element-244" data-mp="1a9r7hze9zrci">
                  {skill.name}
                </h3>
                {skill.endorsements && <span className="whitespace-nowrap text-sm font-semibold text-gold-deep" data-id="element-245" data-mp="10jpi94a6s2w0">
                    {skill.endorsements}
                    <span className="ml-1 text-[11px] font-medium uppercase tracking-wide text-slate-400" data-id="element-246" data-mp="1o90oh1ab2phj">
                      endorsements
                    </span>
                  </span>}
              </div>
              <p className="mt-2 text-[11px] font-semibold uppercase tracking-overline text-slate-400" data-id="element-247" data-mp="38sdv0rtwzzue">
                {skill.category}
              </p>
              {skill.notes.length > 0 && <ul className="mt-4 flex flex-col gap-2 border-t border-mist pt-4" data-id="element-248" data-mp="3ii5r5qhnx10z">
                  {skill.notes.map(note => <li key={note} className="flex gap-2 text-sm leading-relaxed text-charcoal" data-id="element-249" data-mp="2utmllipzz2cl">
                      <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-gold-deep" aria-hidden="true" data-id="element-250" data-mp="2pujr2s7n8eiv" />
                      <span data-id="element-251" data-mp="2ytomvqrtltrc">{note}</span>
                    </li>)}
                </ul>}
            </motion.li>)}
        </ul>
      </div>
    </section>;
}